import type { ApiTheme } from "@/features/themes/types";
import type { ApiSuccessRatePerTopicStat } from "../types";

/**
 * Adapts a topic (`ApiTheme`, from `GET /topics/?with_success_rate=true`) to the
 * success-rate view model consumed by the Partie 2 widgets. `success_rate` stays
 * a ratio in [0, 1] (null when there are too few respondents).
 */
export function mapThemeToTopicStat(
  theme: ApiTheme,
): ApiSuccessRatePerTopicStat {
  return {
    topic_id: theme.id,
    topic_name: theme.name,
    success_rate: theme.success_rate,
    resolved_count: theme.resolved_count,
    attempts_count: theme.respondents_count,
  };
}
